import React from "react";

const Header = () => (
  <header
    style={{
      padding: "20px 40px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <h2 style={{ color: "#00ffff" }}>FrancoLab</h2>

    <button
      style={{
        background: "transparent",
        border: "1px solid #00ffff",
        color: "#00ffff",
        padding: "10px 20px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
    >
      Hire Me
    </button>
  </header>
);

export default Header;